function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 2",
  viewBox: "0 0 50 35.23"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.95 5.5a6.29 6.29 0 0 0-4.42-4.45C40.63 0 25 0 25 0S9.36 0 5.47 1.05A6.29 6.29 0 0 0 1.05 5.5C0 9.43 0 17.61 0 17.61s0 8.19 1.05 12.11a6.29 6.29 0 0 0 4.42 4.45C9.37 35.22 25 35.22 25 35.22s15.64 0 19.53-1.05a6.27 6.27 0 0 0 4.42-4.45C50 25.8 50 17.61 50 17.61s0-8.19-1.05-12.11M19.89 25.05V10.18l13.07 7.43-13.07 7.43Z",
  "data-name": "Layer 1-2",
  style: {
    fill: "#102a56"
  }
})));
export default SvgYoutubeIcon;